import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppLayout = _resolveComponent("AppLayout")!

  return (_openBlock(), _createBlock(_component_AppLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Главная", -1)
            ]))]),
            _: 1
          }),
          _cache[1] || (_cache[1] = _createElementVNode("span", null, " → ", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "Каталог продукции", -1))
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "page-title" }, "Каталог продукции", -1)),
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "intro-text" }, "Подробный каталог продукции", -1)),
        _createElementVNode("a", {
          href: _ctx.catalogPdfUrl,
          class: "catalog-download-card",
          download: "каталог_двери.pdf"
        }, [
          _createElementVNode("img", {
            src: _ctx.catalogCoverSrc,
            alt: "Каталог продукции",
            class: "catalog-cover"
          }, null, 8, _hoisted_4),
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "download-label" }, "Скачать", -1))
        ], 8, _hoisted_3),
        _cache[6] || (_cache[6] = _createElementVNode("p", { class: "download-hint" }, "Нажмите для скачивания каталога (PDF)", -1))
      ])
    ]),
    _: 1
  }))
}